import { gql } from '@apollo/client';

export const TRAINER_CHECK_IN_FRAGMENT = gql`
  fragment TrainerCheckInFragment on TrainerCheckIn {
    __typename
    _id
    trainerId
    userId
    user {
      _id
      name
      avatarUrl
      email
    }
    subscriptionId
    assessmentCheckInId
    conversationId
    periodStartAt
    periodEndAt
    dueAt
    scheduledStartAt
    scheduledEndAt
    meetingUrl
    calendarId
    calendarSequence
    rescheduledAt
    rescheduledByUserId
    canceledAt
    status
    preferredTimes
    userNotes
    trainerNotes
    completedAt
    createdAt
    updatedAt
  }
`;

export const GET_TRAINER_CHECK_INS = gql`
  query GetTrainerCheckIns($input: TrainerCheckInsQueryInput) {
    trainerCheckIns(input: $input) {
      ...TrainerCheckInFragment
    }
  }
  ${TRAINER_CHECK_IN_FRAGMENT}
`;

export const GET_TRAINER_CHECK_IN = gql`
  query GetTrainerCheckIn($id: ID!) {
    trainerCheckIn(id: $id) {
      ...TrainerCheckInFragment
    }
  }
  ${TRAINER_CHECK_IN_FRAGMENT}
`;

export const REQUEST_TRAINER_CHECK_IN = gql`
  mutation RequestTrainerCheckIn($input: RequestTrainerCheckInInput!) {
    requestTrainerCheckIn(input: $input) {
      ...TrainerCheckInFragment
    }
  }
  ${TRAINER_CHECK_IN_FRAGMENT}
`;

export const SCHEDULE_TRAINER_CHECK_IN = gql`
  mutation ScheduleTrainerCheckIn(
    $id: ID!
    $input: ScheduleTrainerCheckInInput!
  ) {
    scheduleTrainerCheckIn(id: $id, input: $input) {
      ...TrainerCheckInFragment
    }
  }
  ${TRAINER_CHECK_IN_FRAGMENT}
`;

export const COMPLETE_TRAINER_CHECK_IN = gql`
  mutation CompleteTrainerCheckIn(
    $id: ID!
    $input: CompleteTrainerCheckInInput
  ) {
    completeTrainerCheckIn(id: $id, input: $input) {
      ...TrainerCheckInFragment
    }
  }
  ${TRAINER_CHECK_IN_FRAGMENT}
`;

export const CANCEL_TRAINER_CHECK_IN = gql`
  mutation CancelTrainerCheckIn($id: ID!) {
    cancelTrainerCheckIn(id: $id) {
      message
      status
      id
    }
  }
`;
